import React from 'react'
import PropTypes from 'prop-types'
import { partial } from 'lodash-es'
import { Waypoint } from 'react-waypoint'

import { LoaderComponent } from '..'

import './InfiniteListComponent.scss'

const onWaypointEntered = (props) => {
  if (props.hasMoreElements && !props.isInfiniteLoading) {
    props.onInfiniteLoad()
  }
}

const renderLoader = (isInfiniteLoading) => {
  if (!isInfiniteLoading) {
    return null
  }

  return (
    <div className="loader-wrapper">
      <LoaderComponent size="small" />
    </div>
  )
}

const renderTriggerAndLoader = (properties) => {
  const { isInfiniteLoading, scrollableAncestor, waypointKey } = properties

  return (
    <>
      <Waypoint
        onEnter={partial(onWaypointEntered, properties)}
        {...(scrollableAncestor && { scrollableAncestor })}
        {...(waypointKey && { key: waypointKey })}
      />
      {renderLoader(isInfiniteLoading)}
    </>
  )
}

const InfiniteListComponent = (props) => {
  const { children, direction } = props

  return (
    <div className="infinite-list-component">
      {direction === 'top' && renderTriggerAndLoader(props)}
      {children}
      {direction === 'bottom' && renderTriggerAndLoader(props)}
    </div>
  )
}

InfiniteListComponent.propTypes = {
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/no-unused-prop-types
  onInfiniteLoad: PropTypes.func.isRequired,
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/no-unused-prop-types
  isInfiniteLoading: PropTypes.bool.isRequired,
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/no-unused-prop-types
  hasMoreElements: PropTypes.bool.isRequired,
  children: PropTypes.node,
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/no-unused-prop-types
  scrollableAncestor: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.element,
  ]),
  direction: PropTypes.oneOf(['top', 'bottom']),
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/no-unused-prop-types
  waypointKey: PropTypes.string,
}

InfiniteListComponent.defaultProps = {
  direction: 'bottom',
}

export default InfiniteListComponent
